import { render, staticRenderFns } from "./SmartHassanStaffIDCard.vue?vue&type=template&id=3e79b444&scoped=true&"
import script from "./SmartHassanStaffIDCard.vue?vue&type=script&lang=js&"
export * from "./SmartHassanStaffIDCard.vue?vue&type=script&lang=js&"
import style0 from "./SmartHassanStaffIDCard.vue?vue&type=style&index=0&id=3e79b444&lang=scss&scoped=true&"
import style1 from "./SmartHassanStaffIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e79b444",
  null
  
)

export default component.exports